export const contractKeys = {
  all: ['contracts'] as const,

  list: () => [...contractKeys.all, 'list'] as const,
  detail: (id: string) => [...contractKeys.all, 'detail', id] as const,
  listByCompany: (companyId: string) => [...contractKeys.list(), 'byCompany', companyId] as const,
  legacy: () => [...contractKeys.all, 'legacy'] as const,
  stats: (companyId: string) => [...contractKeys.all, 'stats', companyId] as const,
  reserveCode: (companyId: string) => [...contractKeys.all, 'reserve-code', companyId] as const,
}
